import React, { useState } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next"

import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import logo from "../../assets/images/faviconcopy.ico"
import casitaLogoLg from "../../assets/images/casita-logo.svg"
import {
   showRightSidebarAction,
   toggleLeftmenu,
   changeSidebarType,
} from "../../store/actions"
import DownTimeBar from "components/DownTimeBar/DownTimeBar"

const Header = props => {
   const [search, setsearch] = useState(false)

   function tToggle() {
      var body = document.body
      if (window.screen.width <= 600) {
         body.classList.toggle("sidebar-enable")
      } else {
         body.classList.toggle("vertical-collpsed")
         body.classList.toggle("sidebar-enable")
      }
   }

   return (
      <React.Fragment>
         <header id="page-topbar" className="gt-topbar">
            <div className="navbar-header">
               <div className="d-flex">
                  <div className="navbar-brand-box  d-md-block ">
                     <Link to="/" className="logo logo-light">
                        <span className="logo-sm">
                           <img src={logo} alt="" className="casita-favicon" />
                        </span>
                        <span className="logo-lg">
                           <img src={casitaLogoLg} className="casita-favicon" />
                        </span>
                     </Link>
                  </div>
                  <button
                     type="button"
                     onClick={() => {
                        tToggle()
                     }}
                     className="btn btn-sm px-3 header-item "
                     id="vertical-menu-btn"
                  >
                     <i className="bx bx-bar-chart bx-rotate-90 bx-sm"></i>
                  </button>
               </div>

               <DownTimeBar />
               <div className="d-flex">
                  <div className="dropdown d-inline-block d-lg-none ms-2">
                     <button
                        onClick={() => {
                           setsearch(!search)
                        }}
                        type="button"
                        className="btn header-item noti-icon "
                        id="page-header-search-dropdown"
                     >
                        <i className="mdi mdi-magnify" />
                     </button>
                     <div
                        className={
                           search
                              ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                              : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                        }
                        aria-labelledby="page-header-search-dropdown"
                     >
                        <form className="p-3">
                           <div className="form-group m-0">
                              <div className="input-group">
                                 <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search ..."
                                    aria-label="Recipient's username"
                                 />
                                 <div className="input-group-append">
                                    <button
                                       className="btn btn-primary"
                                       type="submit"
                                    >
                                       <i className="mdi mdi-magnify" />
                                    </button>
                                 </div>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>

                  <ProfileMenu />
               </div>
            </div>
         </header>
      </React.Fragment>
   )
}

const mapStatetoProps = state => {
   const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
      state.Layout
   return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
   showRightSidebarAction,
   toggleLeftmenu,
   changeSidebarType,
})(withTranslation()(Header))
